import React from 'react';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material';

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 40,
  height: 22,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 18,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(12px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 4,
    '&.Mui-checked': {
      transform: 'translateX(18px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#5D87FF ',
        ...theme.applyStyles?.('dark', {
          backgroundColor: '#F7526A',
        }),
      },
    },
    '&.Mui-disabled': {
      color: '#FFFFFF',
      '&.Mui-checked': {
        color: '#FFFFFF',
      },
      '& + .MuiSwitch-track': {
        backgroundColor: '#5D87FF',
        opacity: 0.5,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 14,
    height: 14,
    borderRadius: 20,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
    '&.Mui-disabled': {
      backgroundColor: theme.palette.grey[400],
    },
  },
  '& .MuiSwitch-track': {
    borderRadius: 24 / 2,
    opacity: 1,
    backgroundColor: 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
    ...theme.applyStyles?.('dark', {
      backgroundColor: 'rgba(255,255,255,.35)',
    }),
    '&.Mui-disabled': {
      backgroundColor: theme.palette.grey[300],
    },
  },
}));

const SwitchComponent = (props) => {
  return (
    <div>
      <AntSwitch {...props} />
    </div>
  );
};

export default SwitchComponent;
